<div class="header-box">
  <h2 class="header" mat-dialog-title>
    {{ "front.create-task-modal.send-task-to-team-member" | translate }}
  </h2>
</div>
<div [formGroup]="form" class="form">
  <div>
    <label for="location" class="input-header">
      {{ "front.create-task-modal.search-room-number" | translate }}</label
    >
    <app-location-autocomplete [parentForm]="form" id="location" />
  </div>

  <div>
    <p class="input-header">
      {{ "front.create-task-modal.patient-name" | translate }}
    </p>
    <p class="form-control not-found" style="height: 38px">
      {{ filteredPatient() ?? "front.create-task-modal.not-found" | translate }}
    </p>
  </div>

  <div>
    <p class="input-header">
      {{ "front.create-task-modal.what-does-patient-need" | translate }}
    </p>
    <input
      class="form-control"
      formControlName="description"
      [placeholder]="'front.create-task-modal.start-typing' | translate"
    />
  </div>
</div>
<div class="btn-box">
  <cancel-btn
    mat-dialog-close
    [label]="'front.create-task-modal.cancel-task'"
  ></cancel-btn>
  <save-btn
    [disabled]="!filteredPatient()"
    mat-dialog-close
    (click)="save()"
    [label]="'front.create-task-modal.send-task'"
  ></save-btn>
</div>
